import React from 'react';
import { Mail, Phone, MapPin, ArrowUpRight, ArrowUp } from 'lucide-react';

export const NewFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-900 border-t border-white/10 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-t from-blue-900/20 to-transparent"></div>
        <div className="absolute bottom-0 right-0 w-1/3 h-full bg-gradient-to-t from-cyan-900/20 to-transparent"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="/narcx_logo_full.png" 
                alt="NarcX+™ Logo" 
                className="h-12 w-auto"
              />
            </div>
            
            <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
              The first and only environmentally friendly method of on-site drug disposal that is validated and meets CFR compliance standards. 
              Providing safe, CFR-compliant solutions for organizations nationwide.
            </p>

            {/* Contact Info Cards */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-200">
                <Phone className="w-5 h-5 text-blue-400" />
                <span>+1 (800) 307-2514</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-200">
                <Mail className="w-5 h-5 text-blue-400" />
                <span>sales@narcx.com</span>
              </div>
              <div className="flex items-start space-x-3 text-gray-300">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span>1633 W. Innovation Way<br />Ste. 05-162, Lehi, UT 84043</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-6 text-lg">Solutions</h3>
            <ul className="space-y-3">
              <li>
                <a href="#benefits" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center group">
                  Why NarcX™
                  <ArrowUpRight className="ml-2 w-4 h-4 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-200" />
                </a>
              </li>
              <li>
                <a href="#industries" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center group">
                  Industries
                  <ArrowUpRight className="ml-2 w-4 h-4 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-200" />
                </a>
              </li>
              <li>
                <a href="https://www.narcx.com/products/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center group">
                  Products
                  <ArrowUpRight className="ml-2 w-4 h-4 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-200" />
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center group">
                  Contact
                  <ArrowUpRight className="ml-2 w-4 h-4 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 transition-all duration-200" />
                </a>
              </li>
            </ul>
          </div>

          {/* Compliance */}
          <div>
            <h3 className="text-white font-bold mb-6 text-lg">Compliance</h3>
            <ul className="space-y-3">
              <li>
                <span className="text-gray-400">CFR Compliance</span>
              </li>
              <li>
                <span className="text-gray-400">21 CFR 1300.05</span>
              </li>
              <li>
                <span className="text-gray-400">EPA Guidelines</span>
              </li>
              <li>
                <span className="text-gray-400">Federal Standards</span>
              </li>
            </ul>
            
            {/* Back to Top Button */}
            <button 
              onClick={scrollToTop}
              className="mt-8 inline-flex items-center px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg text-white transition-all duration-200 hover:scale-105 group"
            >
              <ArrowUp className="w-4 h-4 mr-2 group-hover:-translate-y-1 transition-transform" />
              Back to Top
            </button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-center md:text-left">
              © 2026 NarcX™. All rights reserved.
            </div>
            
            <div className="flex flex-wrap justify-center md:justify-end items-center space-x-6 text-sm">
              <span className="text-gray-400">Made with precision for pharmaceutical safety</span>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                <span className="text-green-400 text-sm font-medium">CFR Compliant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};